import { InjectionToken } from '@angular/core';

export interface FileUploadInterface {
  upload(file: File | Blob, fileName?: string): Promise<FileUploadFile>;
  search(query: string): Promise<FileUploadFile[]>;
  // Document-aware methods now part of the main interface
  uploadToDocuments?(file: File | Blob, fileName?: string, parentFolderId?: string): Promise<FileUploadFile>;
  searchDocuments?(query: string, folderId?: string): Promise<FileUploadFile[]>;
  getRecentUploads?(limit?: number): Promise<FileUploadFile[]>;
  getFilesInFolder?(folderId?: string): Promise<FileUploadFile[]>;
}

export const FILE_UPLOAD_SERVICE_TOKEN =
  new InjectionToken<FileUploadInterface>('FILE_UPLOAD_SERVICE_TOKEN');

export interface FileUploadFile {
  id: string;
  name: string;
  type: string;
  url: string;
  // Extended properties for document integration
  documentId?: string;
  parentFolderId?: string;
  createdAt?: string;
  fileSize?: number;
  documentType?: string; // ClassJax document type (markdown, jaxdoc, file, etc.)
}

export const base64ToBinary = (base64: string) => {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

export const hexToBinary = (hex: string) => {
  const buffer = new ArrayBuffer(hex.length / 2);
  const view = new DataView(buffer);
  for (let i = 0; i < hex.length; i += 2) {
    view.setUint8(i / 2, parseInt(hex.substr(i, 2), 16));
  }
  return buffer;
};

export const hexToBase64 = (hexString: string): string => {
  return btoa(
    hexString
      .match(/\w{2}/g)!
      .map((char) => {
        return String.fromCharCode(parseInt(char, 16));
      })
      .join('')
  );
};
